import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 471px;
    height: 37px;
    border: 1px solid #979797;
    box-sizing: border-box;
    margin: 0 auto;
`; 